export function cleanNumberInput(value: string) {
  const cleanValue = Number(String(value).replace(/\D/g, ''));
  return cleanValue > 0 ? cleanValue : '';
}

export function cleanDecimal(value: string): string {
  if (!value) {
    return '';
  }

  const r = String(value)
    .replace(/[^\d.,]/g, '')
    .replace(',', '.');

  return r;
}

export const convertUMToMM = (thicknessUM: number): number => {
  return Math.round(thicknessUM / 1000);
};
export const convertMMToUM = (thicknessMM: number): number => {
  return Math.round(thicknessMM * 1000);
};
